var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "custom-multiselect-style placeholder-italic",
      class: _vm.getParentCustom,
    },
    [
      _c("multiselect", {
        attrs: {
          options: _vm.availabilityOptions,
          placeholder: "Select gender",
          searchable: false,
          "show-no-results": false,
          openDirection: _vm.below,
          taggable: false,
          showLabels: false,
          "show-labels": false,
        },
        on: { input: _vm.updateSelection, change: _vm.updateSelection },
        model: {
          value: _vm.selectedOption,
          callback: function ($$v) {
            _vm.selectedOption = $$v
          },
          expression: "selectedOption",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }